import { config } from 'lib-shared-backend-config';
const backendDomainParam = config.backendDomain
    ? {
        'backend-domain': config.backendDomain,
    }
    : undefined;
/** Redirects the browser to the login page with the noToken param set. */
export function noTokenRedirect() {
    const params = new URLSearchParams({
        noToken: 'true',
        ...backendDomainParam,
    }).toString();
    document.location.href = `${config.url.logIn}?${params}`;
}
/** Redirects the browser to the login page with the signedOut param set. */
export function loggedOutRedirect() {
    const params = new URLSearchParams({
        signedOut: 'true',
        ...backendDomainParam,
    }).toString();
    document.location.href = `${config.url.logIn}?${params}`;
}
//# sourceMappingURL=redirect.js.map